import type { AxiosInstance } from 'axios';
import type {
  AssistantConversationDetail,
  AssistantConversationSummary,
  AssistantMessageRating,
} from '@/api/ai/ai.types';

/**
 * Persisted AI assistant conversations — list / get / rename / delete, plus
 * the per-message thumbs-up / thumbs-down rating endpoint.
 *
 * The streaming `POST /v1/ai/chat` itself is consumed by `useChat` directly
 * over `fetch` (see `@/api/ai/ai.service.ts`) and is *not* mirrored here.
 */
export const createAiConversationsApi = (api: AxiosInstance) => ({
  list: () =>
    api.get<AssistantConversationSummary[]>('/v1/ai/conversations'),

  get: (id: string) =>
    api.get<AssistantConversationDetail>(`/v1/ai/conversations/${id}`),

  rename: (id: string, title: string | null) =>
    api.patch<{ id: string; title: string | null; updatedAt: string }>(
      `/v1/ai/conversations/${id}`,
      { title },
    ),

  delete: (id: string) =>
    api.delete<void>(`/v1/ai/conversations/${id}`),

  rate: (messageId: string, rating: AssistantMessageRating) =>
    api.post<{
      id: string;
      rating: AssistantMessageRating;
      ratedAt: string | null;
    }>(`/v1/ai/messages/${messageId}/rating`, { rating }),
});
